import React from 'react';
import LazyLoad from 'react-lazyload';
import { TAG } from 'shared/constants';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const LazyImage = props => {
  const { tag, src, alt, loadingMethod = 'lazy' } = props;

  return (
    <>
      {tag === TAG.IMG ? (
        <LazyLoadImage src={src} alt={alt} loading={loadingMethod} {...props} />
      ) : (
        <LazyLoad>
          <div style={{ backgroundImage: `url(${src})`, ...props?.style }} {...props} />
        </LazyLoad>
      )}
    </>
  );
};

export default LazyImage;

